<template>
	<div class="order-items">
		<div
			class="order-item mb-2"
			v-for="(item, index) in items"
			:key="index">
			<div>{{ item.product_name }}</div>
			<div
				class="text-small text-bold"
				v-if="item.variation">
				{{ item.variation.replace(/\|\|/g, ' - ') }} (x{{ item.qty }})
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'OrderItems',
	props: {
		items: {
			type: Array,
			default: () => [],
		},
	},
};
</script>
